import { render } from "./MTestsuits1BtnView.vue?vue&type=template&id=ad54d30a"
import script from "./MTestsuits1BtnView.vue?vue&type=script&lang=js"
export * from "./MTestsuits1BtnView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__